import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IBtn, IFpxShell, IShellButtonAction } from '@fpx/common/models';

/** Repair  shell */
@Injectable({
  providedIn: 'root',
})
export class FpxRepairShellService implements IFpxShell {
  formGroup!: FormGroup<any>;
  onBtnClick = (action: keyof IShellButtonAction) => {};

  doPreInit(): void {
    throw new Error('Method not implemented.');
  }

  onResubmit = (): void => {};
  onBack = (): void => {};
  onRevert = (): void => {};

  btnList: IBtn[] = [];

  _setFormGroup(form: FormGroup) {
    this.formGroup = form;
    this.loadDependencies();
  }

  loadDependencies(): void {
    this.btnList = [
      {
        label: 'Back',
        buttonAction: 'onBack',
        buttonClass: 'btn-secondary',
        buttonType: 'button',
      },
      {
        label: 'Resubmit',
        buttonAction: 'onResubmit',
        buttonClass: 'btn-primary',
        buttonType: 'button',
      },
      {
        label: 'Revert',
        buttonAction: 'onRevert',
        buttonClass: 'btn-secondary',
        buttonType: 'button',
      },
    ];
  }
}
